<template>
    <div class="HomeEvalD">
        <div class="titlePage">Autoevaluación</div>
        <!-- <i class="fa fa-spinner fa-spin fa-3x fa-fw iconload" aria-hidden="true" v-if="iconLoad"></i> -->
        <va-notification v-if="evalsExist === false" color="danger" class="refNoData">No se encuentran formularios activos en este momento.</va-notification>
        <va-notification v-if="isBadDate" color="danger" class="refNoData">No se encuentran formularios activos en este momento.</va-notification>
        <template v-else-if="evalsExist">
            <div class="evalDheader">
                <p>Periodos a evaluar</p>
            </div>
            <div class="evalDcontent">
                <div class="evalDAcontent"></div>
                <div class="evalDBcontent">
                    <div class="evalDcard" v-for="period of periods" :key="period.periodo_actual" @click="autoEvaluate(period.periodo_actual)">
                        <i class="fa fa-calendar-o"></i>
                        <div v-for="(sucperiod, index) of successPeriods" :key="index">
                            <i :class="sucperiod.icon" v-if="sucperiod.period.toString() === period.periodo_actual.toString()"></i>
                        </div>
                        <h2>Periodo: {{period.periodo_actual}}</h2>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
export default {
  data () {
    return {
      periods: [],
      successPeriods: [],
      roleUser: null,
      form: null,
      evalsExist: null,
      // iconLoad: true,
      isBadDate: false,
      tokenData: null,
    }
  },
  methods: {
    autoEvaluate (period) {
      // var formS = IberoHelpers.getPeriodSuccess(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner)
      // 100053131
      // var formS = IberoHelpers.getPeriodSuccess(this.$store, 100024858)
      // formS.then(dataFormR => {
      //   let autoEvalExist = false
      //   for (let i = 0; i < dataFormR.data.length; i++) {
      //     if (dataFormR.data[i].Id_Period == period) {
      //       autoEvalExist = true
      //     }
      //   }
      //   if (autoEvalExist) {
      //     // ya evaluado horas
      //     // var formSS = IberoHelpers.GetFormSuccess(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner, period, period)
      //     var formSS = IberoHelpers.GetFormSuccess(this.$store, 100024858, period, period)
      //     console.log(formSS)
      //     formSS.then(dataFormR => {
      //       if (dataFormR.data == '') {
      //         const evalData = {
      //           form: this.form,
      //           period,
      //           role: this.roleUser,
      //           formType: this.formType,
      //         }
      //         this.$session.set('evalDo', evalData)
      //         this.$router.push('/admin/FormAutoEvaluation/')
      //       }
      //     })
      //   } else {
      //     const evalData = {
      //       form: this.form,
      //       period,
      //       role: this.roleUser,
      //       formType: this.formType,
      //     }
      //     this.$session.set('evalDo', evalData)
      //     this.$router.push('/admin/TeacherHours/')
      //   }

      // })
      
      var formSS = IberoHelpers.GetFormSuccess(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner, period, period)
      //var formSS = IberoHelpers.GetFormSuccess(this.$store, 100042692, period, period)
          formSS.then(dataFormR => {
            if (dataFormR.data == '') {
              const evalData = {
                form: this.form,
                period,
                role: this.roleUser,
                formType: this.formType,
              }
              this.$session.set('evalDo', evalData)
              this.$router.push('/admin/FormAutoEvaluation/')
            }
          })
    },
    evalExist () {
      // var periodSuccess = IberoHelpers.getPeriodSuccess(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner)
      // var periodSuccess = IberoHelpers.getPeriodSuccess(this.$store, 100024858)

      // periodSuccess.then(periodSuccessData => {
      //   for (let i = 0; i < periodSuccessData.data.length; i++) {
      //     // var formSS = IberoHelpers.GetFormSuccess(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner, periodSuccessData.data[i].Id_Period, periodSuccessData.data[i].Id_Period)
      //     var formSS = IberoHelpers.GetFormSuccess(this.$store, 100024858, periodSuccessData.data[i].Id_Period, periodSuccessData.data[i].Id_Period)
      //     formSS.then(dataFormR => {
      //       console.log(dataFormR, 'dani')
      //       console.log(dataFormR.data, 'dani')
      //       if (dataFormR.data == '') {
      //         let iconVal = {
      //           icon: 'fa fa-exclamation-triangle notEvaluated',
      //           period: periodSuccessData.data[i].Id_Period,
      //         }
      //         this.successPeriods.push(iconVal)
      //       } else {
      //         let iconVal = {
      //           icon: 'fa fa-check evaluated',
      //           period: periodSuccessData.data[i].Id_Period,
      //         }
      //         this.successPeriods.push(iconVal)
      //       }
      //     })
      //   }
      // })
      
      var periodSuccess = IberoHelpers.getTeacherPeriod(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner)
      //var periodSuccess = IberoHelpers.getTeacherPeriod(this.$store, 100042692)
      periodSuccess.then(periodSuccessData => {
        for (let i = 0; i < periodSuccessData.data.length; i++) {
          var formSS = IberoHelpers.GetFormSuccess(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner, periodSuccessData.data[i].periodo_actual, periodSuccessData.data[i].periodo_actual)
          //var formSS = IberoHelpers.GetFormSuccess(this.$store, 100042692, periodSuccessData.data[i].periodo_actual, periodSuccessData.data[i].periodo_actual)
          formSS.then(dataFormR => {
            if (dataFormR.data != '') {
              let iconVal = {
                icon: 'fa fa-check evaluated',
                period: periodSuccessData.data[i].periodo_actual,
              }
              this.successPeriods.push(iconVal)
            }
          });
        }
      });

    },
    getFormId (role, actualPeriod, formType) {
      const dataForm = IberoHelpers.getEvalForm(this.$store, role, actualPeriod, formType)
      dataForm.then(getForm => {
        if (getForm.data) {
          this.evalsExist = true
          this.form = getForm.data[0].Id_Generic_Form
          this.roleUser = role
          // this.iconLoad = false
        } else {
          this.evalsExist = false
          // this.iconLoad = false
        }
      })
    },
    getPeriods () {
      const currentYear = new Date().getFullYear().toString()
      const previousYear = (new Date().getFullYear() - 1).toString()

      IberoHelpers.getTeacherPeriod(this.$store, this.$session.get('IberoJWTAdminLogin').idBanner)
        .then(periodsData => {
          if (periodsData.data && periodsData.data.length > 0) {
            let filteredPeriods = periodsData.data.filter(period =>
              period.periodo_actual.toString().startsWith(currentYear)
            )
            if (filteredPeriods.length === 0) {
              filteredPeriods = periodsData.data.filter(period => {
                const periodoStr = period.periodo_actual.toString()
                return periodoStr.startsWith(previousYear) &&
                      ['17', '35', '45', '55'].some(suffix => periodoStr.endsWith(suffix))
              })
            }
            if (filteredPeriods.length > 0) {
              this.periods = filteredPeriods
              this.isBadDate = false
            } else {
              this.isBadDate = true
            }
          } else {
            this.isBadDate = true
          }
        })
        .catch(error => {
          console.error('Error obteniendo periodos:', error)
          this.isBadDate = true
        })
    },
  },
  mounted: async function () {
  let loader = this.$loading.show(); 
  try {
    await this.getPeriods();  
    await this.evalExist();   

    const currentDate = new Date();

   
    const tokenData = await IberoHelpers.getToken(this.$store);

   
    const studentRoleData = await IberoHelpers.getUserLoginAuth(this.$store, this.$session.get('IberoJWTAdminLogin').emailCorporative, tokenData);


   
    const aux = studentRoleData.data[0].idUserType;
    let role = 0;
    aux.map(function (value) {
      if (value.Cod_Role === 'DOC') {
        role = value.Id_Role;
      }
    });

    
    const form = await IberoHelpers.getFormType(this.$store, 'ED');
    this.formType = form.data[0].Id_Form_Type;

   
    const datEvalForm = await IberoHelpers.getEvalForm(this.$store, role, currentDate.getFullYear(), this.formType);

    let currentDateSet = currentDate.getFullYear() + '-' + ('0' + (currentDate.getMonth() + 1)).slice(-2) + '-' + ('0' + currentDate.getDate()).slice(-2);
    let d1 = datEvalForm.data[0].Date_Form_Start.split('-');
    let d2 = datEvalForm.data[0].Date_Form_End.split('-');
    let c = currentDateSet.split('-');

    let from = new Date(d1[0], parseInt(d1[1]) - 1, d1[2]);
    let to = new Date(d2[0], parseInt(d2[1]) - 1, d2[2]);
    let check = new Date(c[0], parseInt(c[1]) - 1, c[2]);

   
    if ((check >= from) && (check <= to)) {
      await this.getFormId(role, currentDate.getFullYear(), this.formType);  
    } else {
      console.log('Formulario fuera de fecha');
      this.isBadDate = true;
      // this.iconLoad = false;
    }

  } catch (error) {
    console.error('Error durante el proceso de obtención de datos:', error);
    // this.iconLoad = false;
   
  } finally {
    loader.hide(); 
  }
}
,
}
</script>

<style scoped>
    .HomeEvalD{
        width: 100%;
        height: 100%;
    }
    .titlePage {
      background-color: none;
      color: #d0ab4b;
      border-color: #d0ab4b;
  }

  .formtoev {
    padding: 6px !important;
    box-sizing: border-box;
    border-radius: 7px;
    text-align: center;
    background-color: #a2273c;
    color: #FFF;
    font-weight: bold;
    margin: 0;
    display: block;
    max-width: 90px;
}
    .evalDheader{
        width: 100%;
        padding:10px 0;
        box-sizing: border-box;
        background-color: #4a4848;
        color: #FFF;
        border-radius: 10px 10px 0 0;
        display: flex;
    }
    .evalDheader p{
        margin:0;
        font-weight: bold;
        width: 100%;
        padding:0 10px;
        box-sizing: border-box;
    }
    .evalDcontent{
        width: 100%;
        height: auto;
        padding:10px 0;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }
    .evalDBcontent{
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        flex-wrap: wrap;
        padding:0 30px;
        box-sizing: border-box;
    }
    .evalDcard{

        width: 23%;
        padding: 20px;
        box-sizing: border-box;
        border:1px solid #dddddd;
        border-radius: 5px;
        box-shadow: 1px 1px 7px 0px rgb(208 171 75);
        transition: all 500ms linear;
        cursor: pointer;
        margin:10px 1%;
        position: relative;
        min-width: 250px;
    }
    .evalDcard:hover{
        box-shadow: 9px 7px 7px 0px rgb(208 171 75 / 30%);
    }
    .evalDcard::before{
        content:" ";
        width: 0px;
        height: 100%;
        background-color: #d0ab4b;
        position: absolute;
        left: 0;
        top: 0;
        transition: all 300ms linear;
        border-radius: 5px 0 0 5px;
    }
    .evalDcard:hover::before{
        width: 5px;
    }
    .evalDcard i{
        font-size: 2.3em;
        color:#222;
        margin-bottom: 10px;
    }
    .evaluated,.notEvaluated{
        font-size: 1em !important;
        border-radius: 50%;
        color: #FFF !important;
        background-color: green;
        position: absolute;
        right: 10px;
        top: 10px;
        padding: 7px;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .notEvaluated{
      background-color: #e14c1f;
    }
    .evalerror{
        font-size: 1em !important;
        border-radius: 50%;
        color: #FFF !important;
        background-color: #e14c1f;
        position: absolute;
        right: 10px;
        top: 10px;
        padding: 7px;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .evalDcard h2{
        font-weight: bold;
        color: #d0ab4b;
        font-size: 17px;
        text-transform: uppercase;
    }
    .evaluated{
        font-size: 1em !important;
        border-radius: 50%;
        color: #FFF !important;
        background-color: green;
        position: absolute;
        right: 10px;
        top: 10px;
        padding: 7px;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .iconload{
        color: #dddddd;
        font-size: 4em;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,0);
        -webkit-transform: translate(-50%,0);
    }
</style>
